module.exports = __webpack_public_path__ + "static/media/banner.170511d9.png";